<template lang="pug">
app-dialog( v-model="$_show" header="Редактировать регион" width="800" )
  v-layout
    v-flex( xs6 )
      expert-region-form( ref="formRegion" :form.sync="form" )
    v-flex.ml-6( xs6 )
      expert-region-organisation-form( :form.sync="form" )
  v-layout
    expert-bank-account-form( ref="formBankAccount" :form.sync="form.bankAccount" )
  .d-flex.flex-row-reverse
    app-button-action( @click="confirmSave()" ) Сохранить
</template>

<script>
import { AppDialogToggable } from "@/components"
import ExpertRegionForm from "../forms/ExpertRegionForm.vue";
import ExpertRegionOrganisationForm from "../forms/ExpertRegionOrganisationForm.vue";
import ExpertBankAccountForm from '../forms/ExpertBankAccountForm.vue';

export default {
  name: "ExpertEditRegionDialog",
  mixins: [AppDialogToggable],

  components: {
    ExpertRegionForm,
    ExpertRegionOrganisationForm,
    ExpertBankAccountForm
  },

  props: {
    form: null
  },

  methods: {
    confirmSave() {
      if (this.$refs.formRegion.$refs.regionForm.validate() && this.$refs.formBankAccount.$refs.bankAccountForm.validate()) {
        this.$emit('save', this.form)
        this.$_show = false
      }
    }
  }

}
</script>